export default {
    value: 'state value',
};
